import React from 'react';
import styled from 'styled-components';
import {Close, Replay} from '@mui/icons-material';
import {COLORS, FONTS, SIZES, Typography} from '@fupa/fupa-uikit';
import {IconButton} from '@mui/material';

const Wrapper = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: ${SIZES['64']};
  padding: ${SIZES['16']};
  width: 100%;
  height: 100%;
  z-index: 10002;
  background-color: ${COLORS.black};
`;

const OverlayContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;

const ButtonWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 0 ${SIZES['32']};
`;

const Label = styled(Typography)`
  font-size: ${FONTS['16']};
  margin-top: ${SIZES['16']};
`;

export const ErrorOverlay = ({show, handleClose, handleRetry, isMobile}) => {
  if (!show) return null;
  return (
    <Wrapper>
      <Typography variant={'title1'}>
        Es ist ein Netzwerkfehler aufgetreten und das Video kann nicht abgespielt werden.
      </Typography>
      <OverlayContainer>
        <ButtonWrapper>
          <IconButton
            onClick={handleClose}
            title='Schließen'
            size={isMobile ? 'medium' : 'large'}
            sx={{'&:hover': {backgroundColor: 'rgba(255,255,255,0.2)'}}}>
            <Close color='icon-invert' />
          </IconButton>
          <Label variant='title1'>Schließen</Label>
        </ButtonWrapper>
        <ButtonWrapper>
          <IconButton
            onClick={handleRetry}
            title='Erneut versuchen'
            size={isMobile ? 'medium' : 'large'}
            sx={{'&:hover': {backgroundColor: 'rgba(255,255,255,0.2)'}}}>
            <Replay color='icon-invert' />
          </IconButton>
          <Label variant='title1'>Erneut versuchen</Label>
        </ButtonWrapper>
      </OverlayContainer>
    </Wrapper>
  );
};
